import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin: 2rem 8%;
  text-align: center;
  height: 100%;
`

export const StakeBridgeContainer = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
  margin: 2rem 8%;
  text-align: center;
`

export const BridgeStatistics = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(50px);
  padding: 0 2rem;
  text-align: left;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const StatisticsTvl = styled.div`
  width: 50%;
  padding: 2rem 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const BridgeTvlInUsd = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: inline-block;
  }
`

export const BridgeTvlInUsdMedia = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`

export const Con = styled.div`
  position: relative;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const StatisticsTitle = styled.div`
  font-size: 18px;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
  }
`

export const StatisticsAvg = styled.div`
  width: 50%;
  padding: 2rem 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Img = styled.img`
  width: 3rem;
  margin-top: 5px;
  margin-bottom: auto;
  top: 0;
  bottom: 0;
  position: absolute;
`

export const Data = styled.div`
  font-size: 28px;
  font-family: Inter-Bold, Inter;
  font-weight: bold;
  justify-content: space-between;
  display: flex;
  width: calc(100% - 4rem);
  padding: 0 1rem 0 4rem;
`

export const Data1 = styled.span`
  color: #808080;
  font-size: 15px;
`

export const LineStyle = styled.div<{
  isdark: boolean
}>`
  height: 100%;
  border-left: ${(props) =>
    props.isdark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #EBEFF2'};
  margin: 0 2rem;

  @media (max-width: 768px) {
    width: 100%;
    border-bottom: ${(props) =>
      props.isdark
        ? '1px solid rgba(255, 255, 255, 0.1)'
        : '1px solid #EBEFF2'};
    margin: 2rem 0;
  }
`

export const Gap = styled.div`
  width: 100%;
  margin: 1rem 0;
`

export const Main = styled.div`
  width: 100%;
  margin-top: 2rem;
  height: calc(100% - 140px - 2rem);
  display: flex;
  flex-direction: column;
`

export const Header = styled.div<{
  isDark: boolean
}>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .ant-input {
    color: ${(props) => (props.isDark ? '#fff' : '#000')};
    font-size: 16px;
    background-color: ${(props) =>
      props.isDark ? 'rgba(0, 0, 0, 0.1)' : '#EBEFF2'};
    border-radius: 20px !important;
    border: ${(props) =>
      props.isDark
        ? '1px solid rgba(255, 255, 255, 0.15)'
        : '1px solid rgba(0, 0, 0, 0.1)'};
  }
  .ant-input:hover {
    border: 1px solid rgba(255, 255, 255, 0.15);
  }
  .ant-input:focus {
    box-shadow: none;
  }
  .ant-input-group {
    border-radius: 20px !important;
  }
  .ant-input-group-addon {
    display: none;
  }
`

export const Title = styled.span`
  font-size: 24px;
  font-family: Inter-Bold, Inter;
  font-weight: bold;
`

export const MyDele1 = styled.span`
  font-size: 18px;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  line-height: 21px;
  display: inline-block;
  margin-right: 1rem;
`

export const MyDele2 = styled.span`
  font-size: 18px;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  line-height: 21px;
  display: inline-block;
  margin-right: 1rem;

  @media (max-width: 768px) {
    display: none;
  }
`

export const FilterArea = styled.div<{
  isDark: boolean
}>`
  margin-top: 1rem;
  display: flex;
  width: 100%;
  justify-content: space-between;

  .ant-switch-checked {
    background: ${(props) =>
      props.isDark ? '#2FBDF4!important' : '#0F68AA!important'};
    border: none !important;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .ant-switch {
    margin-top: 2px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.1);
  }
  .ant-switch .ant-switch-handle {
    top: 1px;
  }

  .ant-switch-checked .ant-switch-handle {
    top: 2px;
  }

  .ant-switch-small {
    min-width: 36px;
  }

  @media (max-width: 768px) {
    margin-top: 20px;

    .part {
      display: none;
    }
  }
`

export const Part = styled.div<{
  isDark: boolean
}>`
  display: inline-block;

  .ant-radio-button-wrapper {
    min-width: 93px;
    margin: 0 3px;
    background: ${(props) => (props.isDark ? 'rgba(0, 0, 0, 0.1)' : '#EBEFF2')};
    border-radius: 20px;
    border: ${(props) =>
      props.isDark
        ? '1px solid rgba(255, 255, 255, 0.15)'
        : '1px solid rgba(0,0,0,0.1)'};
    color: ${(props) => (props.isDark ? '#818D96' : '#8F9193')};
    font-size: 14px;
  }
  .ant-radio-button-wrapper::before {
    display: none;
  }
  .ant-radio-button-wrapper-checked,
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):focus,
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):first-of-type,
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):active,
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):hover {
    border-color: ${(props) => (props.isDark ? '#2FBDF4' : '#0F68AA')};
    color: ${(props) => (props.isDark ? '#2FBDF4' : '#0F68AA')};
  }
`

export const PartMedia = styled.div<{
  isDark: boolean
}>`
  display: none;

  @media (max-width: 768px) {
    display: block;

    .ant-select-selector {
      border: ${(props) =>
        props.isDark
          ? '1px solid #14DACA!important'
          : '1px solid rgba(0,0,0,0.1)!important'};
      color: ${(props) =>
        props.isDark ? '#14DACA!important' : '#8F9193!important'};
      border-radius: 20px !important;
      background: ${(props) =>
        props.isDark ? '#2B0F14!important' : '#EBEFF2!important'};
    }
  }
`

export const MainArea = styled.div<{
  $loading: boolean
}>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.$loading ? 'none' : 'repeat(4, 1fr)'};
  grid-column-gap: 1rem;
  width: 100%;
  margin-top: 2rem;
  justify-content: space-between;
  place-content: center;
  flex-grow: 1;

  @media (max-width: 768px) {
    grid-template-columns: ${(props) => (props.$loading ? 'none' : '100%')};
  }
`
